import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Spinner = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "loader"
    });
};
export default Spinner;
